<template>
  <router-link
    v-if="routeName !== 'Welcome'"
    :to="{ name: 'Home' }"
    title="99 Empresas"
  >
    <img
      :src="
        miniDrawer
          ? require('@/assets/img/99icon_black.svg')
          : require('@/assets/img/99icon_white.svg')
      "
      class="toolbar__logo"
      alt="99 Empresas"
    >
  </router-link>
</template>

<script>
export default {
  name: 'Brand',
  props: {
    miniDrawer: {
      type: Boolean
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  }
}
</script>

<style lang="scss">
.toolbar__logo {
  left: 50%;
  opacity: 1;
  position: fixed;
  top: 24px;
  transform: translateX(-50%);
  transition: 0.2s ease-in all;
  z-index: 3;
  display: none;
  @media (min-width: 768px) {
    left: 96px;
    transform: none;
    display: block;
  }
}
</style>
